var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("li", { staticClass: "search__categories-item" }, [
    _c("a", {
      staticClass: "search__categories-anchor",
      attrs: {
        href: _vm.url,
        "data-index": _vm.index,
        "data-search-suggest-category": _vm.name,
      },
      domProps: { innerHTML: _vm._s(_vm.highlightedName) },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }